import { Button, CircularProgress, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import type { AsyncOptions } from './useAsyncOptions';

export function OptionsFeedback({
  query,
  label,
}: {
  query: AsyncOptions<unknown>;
  label: string;
}) {
  if (query.status === 'error') {
    return (
      <Alert
        severity="error"
        action={
          <Button
            onClick={query.retry}
            aria-label={`Tentar novamente: ${label}`}
          >
            Tentar novamente
          </Button>
        }
      >
        Erro ao carregar {label}. Tente novamente.
      </Alert>
    );
  }
  if (query.status === 'loading') {
    return (
      <Typography component="div" role="status" variant="body2">
        <CircularProgress size={16} /> Carregando {label}...
      </Typography>
    );
  }
  if (query.status === 'success' && query.items.length === 0) {
    return (
      <Typography role="status" variant="body2">
        {label}: nenhuma opção disponível.
      </Typography>
    );
  }
  return null;
}
